export const FILTER_LAYOUT_TYPES = {
  DESKTOP: 'desktop',
  MOBILE_COMPACT: 'mobile-compact',
  MOBILE_EXTENDED: 'mobile-extended',
  TABLET: 'tablet',
  INLINE: 'inline',
  STACKED: 'stacked'
} as const

export type FilterLayoutType = typeof FILTER_LAYOUT_TYPES[keyof typeof FILTER_LAYOUT_TYPES]